import { useEffect, useState } from 'react'

import Footer from 'components/Organisms/Footer'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'
import remarkGfm from 'remark-gfm'

const LegalForeverGreen = () => {
  const { i18n } = useTranslation('privacy')
  const mdContentEN = require('./legal-notice-forevergreen.md')
  const mdContentES = require('./aviso-legal-forevergreen.md')

  const [content, setContent] = useState('')

  useEffect(() => {
    fetch(i18n.language === 'es' ? mdContentES : mdContentEN)
      .then(res => res.text())
      .then(text => {
        // Remove YAML frontmatter
        const contentWithoutFrontmatter = text.replace(
          /^---[\s\S]*?---\n\n/,
          '',
        )
        setContent(contentWithoutFrontmatter)
      })
  }, [i18n.language])

  return (
    <>
      <article className="prose prose-lg mx-auto px-4">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeSanitize]}
          components={{
            h1: ({ ...props }) => <h1 {...props} className="text-blue-800" />,
            p: ({ ...props }) => <p {...props} className="text-gray-500" />,
          }}
        >
          {content}
        </ReactMarkdown>
      </article>
      <Footer />
    </>
  )
}

export default LegalForeverGreen
